import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import {
  Card,
  Box,
  Typography,
  Button,
  CircularProgress,
  Chip,
  Divider,
  Stack,
  Avatar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CategoryIcon from "@mui/icons-material/Category";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { API_ENDPOINTS } from "../../../config/api";

const API_URL = API_ENDPOINTS.PRODUCT_TYPES.BASE;
const ProductTypeDetailsContent = () => {
  const { id } = useParams();
  const [productType, setProductType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductType();
  }, []);

  const fetchProductType = async () => {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      setProductType(response.data.productType);
      // console.log(response.data.productType);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product type details:", error);
      setLoading(false);
    }
  };

  if (loading) {
    return <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />;
  }

  if (!productType) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", mt: 5 }}>
        Product type not found
      </Typography>
    );
  }

  return (
    <Box component="section" sx={{ p: { xs: 1, sm: 3 } }}>
      <Card
        sx={{
          boxShadow: 4,
          borderRadius: "16px",
          p: { xs: 2, sm: 4 },
          maxWidth: 600,
          margin: "auto",
          mt: 5,
          background: "linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
          <Avatar sx={{ bgcolor: "primary.main", width: 48, height: 48 }}>
            <CategoryIcon fontSize="large" />
          </Avatar>
          <Typography variant="h4" sx={{ fontWeight: "bold", flexGrow: 1 }}>
            Product Type Details
          </Typography>
          <Link to="/product-types" style={{ textDecoration: "none" }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={{ borderRadius: 2, fontWeight: 500 }}
            >
              Back
            </Button>
          </Link>
        </Stack>

        <Divider sx={{ mb: 3 }} />

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            Name
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 600, letterSpacing: 0.5 }}>
            {productType.name}
          </Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            Publish Status
          </Typography>
          <Chip
            icon={
              productType.publish ? (
                <CheckCircleIcon style={{ color: "#fff" }} />
              ) : (
                <CancelIcon style={{ color: "#fff" }} />
              )
            }
            label={productType.publish ? "Published" : "Unpublished"}
            color={productType.publish ? "success" : "default"}
            size="medium"
            sx={{
              fontWeight: 500,
              fontSize: 16,
              px: 2,
              py: 0.5,
              color: "#fff",
              borderRadius: 2,
              ...(productType.publish ? {} : { backgroundColor: '#e53935' }),
            }}
          />
        </Box>
      </Card>
    </Box>
  );
};

export default ProductTypeDetailsContent;
